import s2r from "./s2r";

export const VsRadio = s2r("vs-radio", {
  events: {
    "vs-change": "onChange",
  },
});

export const VsChk = s2r("vs-chk", {
  events: {
    "vs-change": "onChange",
  },
});
